import { render, staticRenderFns } from "./CreateDeliverysetup.vue?vue&type=template&id=9d353f18&scoped=true"
import script from "./CreateDeliverysetup.vue?vue&type=script&lang=js"
export * from "./CreateDeliverysetup.vue?vue&type=script&lang=js"
import style0 from "./CreateDeliverysetup.vue?vue&type=style&index=0&id=9d353f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d353f18",
  null
  
)

export default component.exports